import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL || "/api";

axios.defaults.withCredentials = true;
axios.interceptors.response.use(r => r, err => {
  const url = err?.config?.url || "";
  if (err?.response?.status === 401 && !url.includes("/auth/") && window.location.pathname !== "/login") window.location.assign("/login");
  return Promise.reject(err);
});

export const api = {
  login: (identifier, password) => axios.post(`${API}/auth/login`, { identifier, password }).then(r => r.data.user),
  logout: () => axios.post(`${API}/auth/logout`).then(r => r.data),
  me: () => axios.get(`${API}/auth/me`).then(r => r.data.user),
  health: () => axios.get(`${API}/health`).then(r => r.data),
  projects: () => axios.get(`${API}/projects`).then(r => r.data.projects),
  addProject: name => axios.post(`${API}/admin/projects`, { name }).then(r => r.data),
  history: () => axios.get(`${API}/chat/history`).then(r => r.data.history || []),
  ask: (question, project_id) => axios.post(`${API}/chat`, { question, project_id }).then(r => r.data),
  report: (name, project_id) => axios.get(`${API}/reports/${name}`, { params: { project_id } }).then(r => r.data),
  sheets: () => axios.get(`${API}/admin/sheets`).then(r => r.data.sheets || []),
  addSheet: form => axios.post(`${API}/admin/sheets`, form).then(r => r.data),
  removeSheet: id => axios.delete(`${API}/admin/sheets/${id}`).then(r => r.data),
  syncSheet: id => axios.post(`${API}/admin/sheets/${id}/sync`).then(r => r.data),
  syncLogs: () => axios.get(`${API}/admin/sync-logs?limit=12`).then(r => r.data.logs || []),
  adminStatus: () => axios.get(`${API}/admin/status`).then(r => r.data),
  clearCache: () => axios.post(`${API}/admin/cache/clear`).then(r => r.data),
};

export const errorText = (err, fallback) => err?.response?.data?.detail || fallback;

export function downloadReport(report) {
  const blob = new Blob([JSON.stringify(report, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "builder-report.json";
  a.click();
  URL.revokeObjectURL(url);
}

export async function downloadReportXlsx(report) {
  const response = await axios.get(`${API}/reports/${report.report_key}`, {
    params: {
      format: "xlsx",
      as_of: report.as_of,
      project_ids: (report.project_ids || []).join(","),
    },
    responseType: "blob",
  });
  const url = URL.createObjectURL(response.data);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `${report.report_key}-report.xlsx`;
  anchor.click();
  URL.revokeObjectURL(url);
}

export function downloadCsv(report) {
  const rows = report.details || [];
  const columns = Object.keys(rows[0] || {});
  const escape = v => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const lines = [["Metric", "Value"], ...report.kpis.map(k => [k.label, k.value]), [], columns, ...rows.map(r => columns.map(c => r[c]))];
  const blob = new Blob([lines.map(l => l.map(escape).join(",")).join("\n")], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${report.report_type.replace(/\W+/g, "-").toLowerCase()}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export const timeAgo = iso => {
  if (!iso) return "never";
  const s = Math.max(0, Math.round((Date.now() - new Date(iso)) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)}m ago`;
  return `${Math.round(s / 3600)}h ago`;
};

let seq = 0;
export const nextId = prefix => `${prefix}-${Date.now().toString(36)}-${++seq}`;
